import { render, staticRenderFns } from "./ComercialInformation.vue?vue&type=template&id=3507435f&lang=pug&"
import script from "./ComercialInformation.vue?vue&type=script&lang=js&"
export * from "./ComercialInformation.vue?vue&type=script&lang=js&"
import style0 from "./ComercialInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ComercialInformation.vue"
export default component.exports